
import { Tooltip } from "@mui/material";
import * as React from "react";
import { getGlobalVar, Helpers } from "../../utils/helpers";

interface LeagueShieldProps {
    rank: number;
    size?: "small" | "medium" | "large";
    showRank?: boolean;
    showLeagueName?: boolean;
}

export const LeagueShield = ({
    rank = 0,
    size = "medium",
    showRank = false,
    showLeagueName = false,
}: LeagueShieldProps) => {
    // Get league config by rank
    const leagues = getGlobalVar("LEAGUES");
    const leagueDivision = leagues.find(item => item.min <= +rank && item.max >= +rank);

    const animateShield = leagueDivision.league === "masters" || leagueDivision.league === "diamond";
    let shieldImage = require(`../../../assets/images/misc/not_found.png`).default;

    switch (leagueDivision.league) {
        case "none":
            shieldImage = require(`../../../assets/images/misc/not_found.png`).default;
            break;
        case "wildcard":
            shieldImage = require(`../../../assets/images/misc/not_found.png`).default;
            break;
        case "bronze":
            shieldImage = require(`../../../assets/images/misc/not_found.png`).default;
            break;
        case "silver":
            shieldImage = require(`../../../assets/images/misc/not_found.png`).default;
            break;
        case "gold":
            shieldImage = require(`../../../assets/images/misc/not_found.png`).default;
            break;
        case "diamond":
            shieldImage = require(`../../../assets/images/misc/not_found.png`).default;
            break;
        case "masters":
            shieldImage = require(`../../../assets/images/misc/not_found.png`).default;
            break;
        default:
            break;
    }

    const shield = <div className={`league_shield__outer_wrapper ${size} ${animateShield ? "animated" : ""}`}>
        <div
            className="league_shield__inner_wrapper"
            {...animateShield && { style: { background: `transparent url("${shieldImage}")` } }}
        >
            <img src={shieldImage}/>
        </div>

        {showLeagueName && <span>
            {Helpers.getLocalizationName(leagueDivision.name)}
        </span>}
    </div>;

    if (showRank) {
        return <Tooltip title={rank} placement="top">
            {shield}
        </Tooltip>
    }

    return shield;
}
